module.exports = __webpack_public_path__ + "img/banner-partnerships-for-the-goals.ece2e182.png";